import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.findWordsStepTwoLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.findWordsStepTwoLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.findWordsStepTwoLevels.data.findWordsStepTwoLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
